import { useNotificationsContext } from '../../ContextProvider/Notifications';
import CCAnnouncementToastColor from '../../../libs/CiscoCore/Announcement/Toast/Color';

export default function NotificationPanel() {
  const { notificationList } = useNotificationsContext();
  return (

      <div className="fixed bottom-2 right-2 space-y-1 z-10">
      {
        !!notificationList && !!notificationList.length &&
        <>
          {
            notificationList.map((notification) => {
                return (
                  <div key={notification.id} className="ml-2 z-10 animate-fade-in-300">
                    <CCAnnouncementToastColor className="animate-fade-out-300-after-4700"
                                              type={notification.type}
                                              hasIcon={notification.showIcon}
                                              text={notification.text}
                                              captionText={notification.caption}
                                              actionLabel={notification.actionLabel}
                                              actionFn={notification.actionFn}
                                              actionFnArgs={notification.actionFnArgs}
                                              dismissControlTitle={notification.dismissControlTitle}
                                              dismissControlFn={notification.dismissFn}
                                              dismissControlFnArgs={notification.dismissFnArgs}/>
                  </div>
                )
              }
            )
          }
        </>
      }
      </div>

  );
}
